module.exports = __webpack_public_path__ + "static/img/1.de23060.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/products/oem/R407C/1.jpg
// module id = NiHC
// module chunks = 1